module.exports = __webpack_public_path__ + "media/images/area/feature/hokkaido/related/ko_1-25bf560e16820a40124584034a639c3b.jpg";